var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColourPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.212,7.232l1.491-1.491l-0.707-0.707C24.792,1.83,20.531,0.065,16,0.065h-1v2.109 c-3.604,0.238-6.962,1.739-9.54,4.317C2.646,9.306,1.095,13.048,1.095,17.03s1.55,7.725,4.366,10.54 c2.815,2.815,6.558,4.366,10.539,4.366s7.724-1.55,10.539-4.366c2.815-2.815,4.366-6.558,4.366-10.54 C30.905,13.385,29.592,9.948,27.212,7.232z M10.581,23.863c1.277,1.017,2.797,1.646,4.419,1.83v4.193 c-2.738-0.209-5.3-1.27-7.384-3.059L10.581,23.863z M17,25.693c1.622-0.184,3.142-0.814,4.419-1.83l2.965,2.965 c-2.084,1.788-4.646,2.85-7.384,3.059V25.693z M22.833,22.448c1.017-1.277,1.646-2.797,1.83-4.419h4.193 c-0.209,2.738-1.27,5.3-3.058,7.384L22.833,22.448z M28.856,16.03h-4.193c-0.184-1.622-0.814-3.142-1.83-4.418l2.965-2.965 C27.586,10.73,28.647,13.292,28.856,16.03z M17,2.098c3.29,0.216,6.373,1.493,8.852,3.667l-5.898,5.898 C19.082,11.018,18.073,10.6,17,10.439V2.098z M19.299,13.731l0.707,0.707l1.399-1.399c0.852,1.15,1.32,2.532,1.32,3.99 c0,1.796-0.7,3.485-1.97,4.755c-1.271,1.27-2.959,1.97-4.755,1.97s-3.485-0.7-4.755-1.97c-1.27-1.271-1.97-2.959-1.97-4.755 s0.7-3.485,1.97-4.755c1.031-1.031,2.339-1.677,3.755-1.888v1.979h1C17.246,12.365,18.417,12.851,19.299,13.731z M7.337,16.03H3.144 c0.209-2.738,1.27-5.3,3.058-7.384l2.965,2.965C8.151,12.888,7.521,14.408,7.337,16.03z M15,8.367 c-1.622,0.184-3.142,0.813-4.419,1.83L7.616,7.232C9.7,5.444,12.262,4.383,15,4.174V8.367z M3.144,18.03h4.193 c0.184,1.622,0.814,3.142,1.83,4.419l-2.965,2.965C4.414,23.33,3.353,20.768,3.144,18.03z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColourPalette);
export default __webpack_public_path__ + "static/media/colour-palette.95130e4bc8b5a2ecbaf50cfacd61184b.svg";
export { ForwardRef as ReactComponent };